import { useSelector } from 'react-redux';

import { useTheme } from '@raystack/apsara';

import { RootState } from '@src/redux/_reducers/rootReducer';
import { DarkThemeMapStyle, getMapStyles } from '@src/utils/maps/styles';

export function useMapStyle() {
  const { resolvedTheme: currentTheme } = useTheme();
  const mapType = useSelector((state: RootState) => state.map.mapType);
  const mapStyles = getMapStyles(currentTheme);

  const currentMapStyle =
    mapStyles.find(style => style.name === mapType) || DarkThemeMapStyle;

  return {
    mapStyles,
    currentMapStyle
  };
}
